// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultValueOption_root__2T5z_","selectLabel":"DefaultValueOption_selectLabel__2zgcj"};